import React, { SetStateAction, useContext, useEffect, useState } from "react";
import {
    Box,
    Button,
    FormControl,
    InputLabel,
    Paper,
    TextField,
    Tooltip,
    Typography,
    IconButton,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Divider,
    SelectChangeEvent,
    Select,
    MenuItem,
} from "@mui/material";
import variables from "../../../assets/styles/variables.module.scss";
import SummaryCard from "../../../Shared-ui/SharedComponents/Cards/SummaryCard";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import RotateLeftOutlinedIcon from "@mui/icons-material/RotateLeftOutlined";
import ReportGmailerrorredOutlinedIcon from "@mui/icons-material/ReportGmailerrorredOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DBForm from "./Form";
import OldAgent from "../../../Shared-ui/Types/OldAgent";
import { DataBase } from "../../../Shared-ui/Types/common";
import { NotSelected } from "../../../Constant/Setting";
import ChatInstance from "../../../Services/AxiosInstance/ChatInstance";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError, ShowSuccess, ShowWarring } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { GET_TABLES } from "../../../Services/Endpoint";
import Confirm, { ConfirmBase } from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import userContext from "../../../Shared-ui/Context/UserContext";


interface MyComponentProps {
    knowledgeBase: OldAgent | any
    setknowledgeBase: React.Dispatch<SetStateAction<OldAgent | any>>
    getknowledgeBase: any
    updateknowledgeBase: any
}


const SourceDatabase: React.FC<MyComponentProps> = (props) => {
    const dataBaseInitial: DataBase = {
        id: 0,
        connectionName: "",
        databaseType: NotSelected,
        server: "",
        databaseName: "",
        user: "",
        password: "",
        port: "",
        selectedTables: [],
    }
    const [expanded, setExpanded] = useState<boolean>(false) // Track expanded panel
    const [dataBases, setDataBases] = useState<DataBase[]>([...props.knowledgeBase.databaseConnections || []])
    const [dataBase, setDataBase] = useState<DataBase>(dataBaseInitial)
    const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false })
    const [showTables, setShowTables] = useState<boolean>(false)
    const [isEditing, setIsEditing] = useState<boolean>(false)
    const [pagination, setPagination] = useState({ page: 0, pageSize: 3 }); // Current page index

    const { user, updateUserContext } = useContext(userContext);
    console.log("UserDetails", user)

    const dispatch = useDispatch()

    const handleCancel = () => {
        setExpanded(false); // Reset expanded state
        setShowTables(false);
        setDataBase(dataBaseInitial)
        setIsEditing(false)

    };
    const handleEdit = (row: DataBase) => {
        setExpanded(true); // Reset expanded state
        setDataBase(row)
        setIsEditing(true)

    };
    const connectDatabase = async () => {

        // setShowTables(true);

        try {
            dispatch(StartLoading())
            const data = await ChatInstance.post(GET_TABLES, dataBase).then(res => res?.data?.detail)
            setShowTables(true);
            const initialTableList = Array.isArray(data.response) ? data.response.map((tableName: string) => {
                let preVal = dataBase?.selectedTables?.filter(item => item[tableName]).map(item => item[tableName])[0]
                return { [tableName]: preVal ? preVal : false }
            }) : [];
            setDataBase((preVal) => ({ ...preVal, selectedTables: initialTableList }))
        } catch (err: any) {
            dispatch(ShowError(err?.response?.data?.response))
        } finally {
            dispatch(StopLoading())

        }


    };

    const addDatabase = async () => {

        const isTableSelected = dataBase?.selectedTables?.some(item =>
            Object.values(item).some(value => value === true)
        );

        if (isTableSelected) {
            props.setknowledgeBase((preVal: OldAgent) => {
                const knowledgeBase = preVal
                const updatedDb = knowledgeBase.databaseConnections?.filter(item => item.connectionName != dataBase.connectionName)
                dataBase.id = knowledgeBase.databaseConnections?.length ? knowledgeBase.databaseConnections?.length + 1 : 0
                dataBase.user = user.email;
                knowledgeBase.databaseConnections = [...updatedDb || [], dataBase]
                setDataBases(knowledgeBase.databaseConnections)
                return knowledgeBase
            })
            await props.updateknowledgeBase()
            handleCancel()
        } else {
            dispatch(ShowWarring("Please select at least one table"));
        }
    };

    const deleteDatabase = async (row: DataBase) => {
        setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
        props.setknowledgeBase((preVal: OldAgent) => {
            const knowledgeBase = preVal

            knowledgeBase.databaseConnections = knowledgeBase.databaseConnections?.filter((item) => item.id !== row.id) || []
            setDataBases(knowledgeBase.databaseConnections)
            return knowledgeBase
        })
        await props.updateknowledgeBase()
    }

    const handlePaginationMetaChange = (paginationMeta: any) => {
        const { page, pageSize, rowCount } = paginationMeta;
        // console.log(`Page: ${page + 1}, Page Size: ${pageSize}, Total Rows: ${rowCount}`);
        setPagination({ page: page, pageSize: pageSize })
        // setPage(page); // Update page
        // setPageSize(pageSize); // Update page size
    };

    const columns: GridColDef[] = [
        // { field: "id", headerName: "ID", width: 70 },
        { field: "connectionName", headerName: "Connection Name", width: 140 },
        { field: "databaseName", headerName: "Database Name", width: 130 },
        { field: "databaseType", headerName: "Type", width: 110 },
        // { field: "lastTrained", headerName: "Last Trained", width: 130 },
        {
            field: "lastTrained",
            headerName: "Last Trained",
            width: 180,
            renderCell: (params) => (
                <div style={{ display: "flex", alignItems: "center" }}>
                    {/* {params.id == 1 && (
                        <Tooltip title="Training completed">
                            <CheckCircleOutlineOutlinedIcon
                                style={{ marginRight: 8, color: variables.successDark }}
                            />
                        </Tooltip>
                    )}
                    {params.id == 2 && (
                        <Tooltip title="Training in progress">
                            <RotateLeftOutlinedIcon
                                style={{ marginRight: 8, color: variables.warningDark }}
                            />
                        </Tooltip>
                    )}
                    {params.id == 3 && (
                        <Tooltip title="Training failed">
                            <ReportGmailerrorredOutlinedIcon
                                style={{ marginRight: 8, color: variables.errorMain }}
                            />
                        </Tooltip>
                    )} */}
                    {props.knowledgeBase.lastTrained || ""}
                </div>
            ),
        },
        {
            field: "Trained Tables",
            headerName: "Trained Tables",
            width: 130,
            renderCell: (params) => {
                const trueCount = params?.row?.selectedTables?.filter((item: any) => Object.values(item)[0] === true).length;
                return <>{`${trueCount}/${params?.row?.selectedTables?.length}`}</>
            }
        },
        {
            field: "createdBy",
            headerName: "Created By",
            width: 130,
            renderCell: (params) => {
                return params?.row?.user
            }
        },
        // { field: "createdOn", headerName: "Created On", width: 130 },
        // { field: "port", headerName: "Port", width: 130 },
        {
            field: "actions",
            headerName: "Actions",
            width: 150,
            renderCell: (params) => {
                const handleEditClick = (event: React.MouseEvent) => {
                    event.stopPropagation(); // Prevent row selection
                    handleEdit(params.row)
                    // console.log("Edit clicked for:", params.row);
                };

                const handleDeleteClick = (event: React.MouseEvent) => {
                    event.stopPropagation(); // Prevent row selection
                    setConfirmPopupData({
                        show: true,
                        setConfirmPopupData: setConfirmPopupData,
                        title: "Confirm Delete",
                        info: "Are you sure want to delete your data? This action cannot be undone.",
                        varient: "delete",
                        functionName: deleteDatabase,
                        functionParam: params.row
                    })
                    // console.log("Delete clicked for:", params.row);
                    // setOpen(true);
                };

                return (
                    <Box>
                        {/*<IconButton aria-label="view">*/}
                        {/*    <VisibilityIcon />*/}
                        {/*</IconButton>*/}
                        <IconButton aria-label="edit" onClick={(e) => handleEditClick(e)}>
                            <EditOutlinedIcon />
                        </IconButton>
                        <IconButton aria-label="delete" onClick={(e) => handleDeleteClick(e)}>
                            <DeleteOutlineOutlinedIcon />
                        </IconButton>
                    </Box>
                );
            },
        },
    ];



    return (
        <Box
            sx={{
                width: "100%",
                display: "block",
                boxSizing: "border-box",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    ml: -2,
                    mr: -2,
                }}
            >
                {/* Left Content */}
                <Box
                    sx={{
                        width: {
                            lg: "calc(100% - 300px)",
                            md: "calc(100% - 300px)",
                            sm: "100%",
                        },
                        flex: "0 0 auto",
                        boxSizing: "border-box",
                        minWidth: {
                            lg: "calc(100% - 300px)",
                            md: "calc(100% - 300px)",
                            sm: "100%",
                        },
                        pl: 2,
                        pr: 2,
                        maxWidth: "100%",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        <Typography variant="h6" gutterBottom>
                            Database
                        </Typography>
                        <Box>
                            <><Tooltip title="Add Database" placement="top">{dataBases.length ? (
                                <IconButton
                                    color="secondary"
                                    aria-label="remove icon"
                                    sx={{ color: variables.primaryColor }}
                                    onClick={() => setExpanded(false)}
                                    disabled
                                >
                                    <AddIcon />
                                </IconButton>
                            ) : (
                                <IconButton
                                    color="secondary"
                                    aria-label="add icon"
                                    sx={{ color: variables.primaryColor }}
                                    onClick={() => setExpanded(true)}
                                >
                                    <AddIcon />
                                </IconButton>
                            )}</Tooltip></>
                        </Box>
                    </Box>

                    {/* Add Connection Box */}
                    {expanded && (
                        <DBForm
                            handleCancel={handleCancel}
                            showTables={showTables}
                            connectDatabase={connectDatabase}
                            dataBase={dataBase}
                            setDataBase={setDataBase}
                            addDatabase={addDatabase}
                            isEditing={isEditing}
                        />
                    )}

                    <Paper sx={{ height: 400, width: "100%", mt: "20px" }} elevation={0}>
                        <DataGrid
                            rows={dataBases}
                            columns={columns}
                            rowCount={dataBases.length}
                            pageSizeOptions={[3]}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        page: pagination.page, // Initial page index (0-based)
                                        pageSize: pagination.pageSize, // Initial page size
                                    },
                                },
                            }}
                            onPaginationModelChange={handlePaginationMetaChange} // Handle pagination meta change
                            paginationMode="client"
                            disableColumnResize // Disables resizing
                            sx={{
                                border: 1,
                                borderColor: variables.borderColor,
                                "& .MuiDataGrid-cell:focus": {
                                    outline: "none",
                                },
                                "& .MuiDataGrid-cell:focus-within": {
                                    outline: "none",
                                },
                            }}
                        />
                    </Paper>
                </Box>

                {/* Right Summary Card */}
                <Box
                    sx={{
                        width: { lg: "300px", md: "300px", sm: "100%" },
                        minWidth: { lg: "300px", md: "300px", sm: "100%" },
                        boxSizing: "border-box",
                        flex: "0 0 auto",
                        pl: 2,
                        pr: 2,
                        mt: { lg: "0", md: "0", sm: "30px" },
                    }}
                >
                    <SummaryCard />
                </Box>
            </Box>
            <ConfirmPopup details={confirmPopupData} />
        </Box>

    );
};

export default SourceDatabase;

